import React, { useEffect, useState } from 'react';
import { TablePagination, Typography } from '@material-ui/core';
import { getCollectiveService } from '../../actions/collective-service-action';
import { getActiveRegionals } from '../../actions/regional-actions';
import { useStateValue } from '../../context/store';
import ModalConfirmBase from '../../utils/form/modalConfirmBase';
import AccordionCollectiveService from './accordionCollectiveService';
import SearchCollectiveService from './searchCollectiveService';
import Search from "../../images/icons/search.svg";
import { styles } from '../styles';
import { allLaboratory } from '../../actions/laboratory-actions';
import ModalServicioColectivo from './createCollectiveService/modalServicioColectivo';
import {permissionsConstans} from '../../constansPermissions';

const CollectiveService = () => {
  const classes = styles();
  const [{filterColService, filterExamByService}, dispatch] = useStateValue();
  const [regionals, setRegionals] = useState([]);
  const [laboratorys, setLaboratorys] = useState([]);

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    threeButtons: false,
    type: "",
    open: false,
  });

  const [data, setData] = useState({
    laboratory: null,
    regional: null,
    initDate: null,
    endDate: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const handleClickClose = () => {
    setMessage({...message, open:false});
  }

  const getRequestService = async () => {
    const filters = {
      initRequestDate: data.initDate === '' ? null : data.initDate,
      endRequestDate: data.endDate === '' ? null : data.endDate,
      medicalLabId: data.laboratory === '' ? null : data.laboratory,
      //regionalId: data.regional === '' ? null : data.regional
    }
    const response = await getCollectiveService(paginadorRequest, filters);
    if(response?.status === 200 || response?.status === 201){
      const data = response?.data?.collectiveServicePage;
      setPaginadorResponse({
        data: data.content,
        totalRows: data.totalElements,
        pageSize: data.size,
        pageNumber: data.number,
      })
    }else if(response?.status > 399 && response?.status !== 401 && response?.status !==403){
      setMessage({
        description : response?.data?.detail ? response?.data?.detail : response?.data?.error,
        textButtonSubmit : 'ACEPTAR',
        handleClick : () => handleClickClose() ,
        oneButtons : true,
        type : 'WARNING',
        open : true
      })
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  }

  useEffect(() => {
    getRequestService();
  }, [paginadorRequest])

  if(filterColService && filterColService.isFilter && data !== filterColService.filter){
    const filter = filterColService?.filter;
    data.initDate = filter.initDate;
    data.endDate = filter.endDate;
    data.regional = filter.regionalId;
    data.laboratory = filter.nameLaboratory;
    paginadorRequest.page = 0;
    getRequestService()
    dispatch({
      type: 'FILTER_COLLECTIVE_SERVICE',
      isFilter: false
    })
  }

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Consultar orden de servicio colectivo",
      breadCrumbSubText: "Consultar orden de servicio colectivo",
      index: 25,
      isCollectiveService: true,
    });
  }, [dispatch])

  useEffect(() => {
    const getAllRegionals = async () => {
      const response = await getActiveRegionals();
      setRegionals(response?.data?.regionalList)
    }
    getAllRegionals();
  }, [])

  useEffect(() => {
    const getAllLaboratory = async () => {
      const filters = {};
      const paginador = {
        page: 0,
        size: 1000,
        order: "DESC",
        columnOrder: "creationDate",
      }
      const response = await allLaboratory(filters, paginador);
      const laboratorys = response?.data?.medicalLabPage?.content.map(x => {
        const lab = {...x, laboratoryName: x?.laboratoryName?.toLowerCase()}
        return lab;
      });
      const orderList = laboratorys && laboratorys.sort((a, b) => {
        return a?.laboratoryName?.localeCompare(b?.laboratoryName);
      })
      setLaboratorys(orderList);
    }
    getAllLaboratory();
  }, [])

  const validPermissionSearch = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "SER_COL");

    if (module?.functionalities?.some((x) => x === permissionsConstans.SER_COL_CONSULTAR)) {
      return (
        <React.Fragment>
          <SearchCollectiveService
            regionals={regionals}
            laboratorys={laboratorys}
          />
        </React.Fragment>
      );
    } else return null;
  };

  return (
    <div>
      {validPermissionSearch()}
      <ModalServicioColectivo
        setMessage={setMessage}
        message={message}
        laboratorys={laboratorys}
        getRequestService={getRequestService}
      />

      {
        paginadorResponse?.data?.map((item) => (
          <AccordionCollectiveService
            data={item}
            message={message}
            setMessage={setMessage}
            handleClickClose={handleClickClose}
          />
        ))
      }

      {paginadorResponse?.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage="Registros por página"
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
        ) : (
          <React.Fragment>
            <div className={classes.messageSearch}>
              <img src={Search} alt="" />
              <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
                No se encontraron registros que coincidan con el filtro de
                búsqueda aplicado
              </Typography>
            </div>
          </React.Fragment>
        )
      }

      <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        threeButtons={message.threeButtons}
        type={message.type}
        open={message.open}
      />
    </div>
  )
}

export default CollectiveService